var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"canvas-container"},[_c('canvas',{ref:"canvas",staticStyle:{"width":"100%","height":"auto"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }